import { useQuery } from '@tanstack/react-query';
import { api, ApiError } from '@/client/lib/api';

export type Me = {
  id: string;
  email: string;
  name: string;
  avatarUrl: string | null;
  locale: 'sk' | 'cs';
  emailVerified: boolean;
  marketingConsent: boolean;
  hasPassword: boolean;
  hasGoogle: boolean;
  hasApple: boolean;
  createdAt: number;
  lastLoginAt: number | null;
  deletedAt: number | null;
  hardDeleteAt: number | null;
};

export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        const data = await api<{ user: Me }>('/api/v1/me');
        return data.user;
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
  });
}
